<template>
    <div class="inner-wrapper global-setting-section">
        <!--<div class="page-title">
            <h1 class="float-left">Global Settings</h1>
            <div class="title-right float-right">
                <a href="#" class="btn custom-btn">New Customer</a>
            </div>
        </div>-->
        <form @submit.prevent="save" id="addCustomerForm" name="addCustomerForm" method="post">
        <div class="select-step global-section">
            <!-- progressbar -->
            <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                <strong class="success_msg">{{successMessage}}</strong>
            </div>
            <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                        <p v-for="error in v" :key="error" class="text-sm">
                            {{ error }}
                        </p>
                    </li>
                </ul>
            </div>
            <div class="card">
                <div class="card-header">
                    <div class="d-flex align-items-center">
                        <h5 class="card-title flex-grow-1 mb-0">IMAP Settings</h5>
                    </div>
                </div>
                <div class="card-body pb-0">
                    <div class="row">
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >IMAP Server</label>
                                <select class="form-control mdl-textfield__input" id="status" name="status" v-model="form.imap_server_name" @change="onImapChange">
                                    <option value="1">Gmail</option>
                                    <option value="2">Outlook</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >IMAP Host</label>
                                <input type="text" v-model="form.imap_host_name" class="form-control" name="imap_port" placeholder="imap.gmail.com">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >IMAP Port</label>
                                <input type="text" class="form-control" name="imap_port"  v-model="form.imap_port" placeholder="993">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >IMAP Encryption</label>
                                <input type="text" class="form-control" name="imap_encryption" v-model="form.imap_encryption" placeholder="ssl">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >IMAP Name</label>
                                <input type="text" class="form-control" id="imap_user_name" v-model="form.imap_user_name" placeholder="">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >IMAP Password</label>
                                <input type="password" class="form-control" name="imap_password" id="imap_password" v-model="form.imap_password" placeholder="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="d-flex align-items-center">
                        <h5 class="card-title flex-grow-1 mb-0">SMTP Settings</h5>
                    </div>
                </div>
                <div class="card-body pb-0">
                    <div class="row">
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >SMTP Server</label>
                                <select class="form-control mdl-textfield__input" id="smtp_server_name" name="status" v-model="form.smtp_server_name" @change="onSmtpChange">
                                    <option value="1">Gmail</option>
                                    <option value="2">Outlook</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >SMTP Host</label>
                                <input type="text" class="form-control" name="imap_port"  v-model="form.smtp_host_name" placeholder="smtp.gmail.com">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >SMTP Port</label>
                                <input type="text" class="form-control" name="imap_port"  v-model="form.smtp_port" placeholder="993">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >SMTP Encryption</label>
                                <input type="text" class="form-control" name="imap_encryption" v-model="form.smtp_encryption" placeholder="ssl">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >User Name</label>
                                <input type="text" class="form-control" name="imap_user_name" v-model="form.smtp_user_name" placeholder="">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >SMTP Password</label>
                                <input type="password" class="form-control" name="imap_password"  v-model="form.smtp_password" placeholder="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="d-flex align-items-center">
                        <h5 class="card-title flex-grow-1 mb-0">Quotation</h5>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row mb-1">
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >Max Products</label>
                                <input type="text" class="form-control" placeholder="Max Products" v-model="form.quote_setting.max_products" >
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >Max Tiers</label>
                                <input type="text" class="form-control" placeholder="Max Tiers" v-model="form.quote_setting.max_tiers" >
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >Address 1</label>
                                <input type="text" class="form-control" v-model="form.quote_setting.address_1" placeholder="36 Van Tassel Ct.">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >Address 2</label>
                                <input type="text" class="form-control" placeholder="Address 2" v-model="form.quote_setting.address_2">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >Phone number</label>
                                <input type="text" class="form-control" v-model="form.quote_setting.phone" placeholder="Phone number">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >Fax</label>
                                <input type="text" class="form-control" v-model="form.quote_setting.fax" placeholder="Fax">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                            <div class="form-group">
                                <label >Lead Time</label>

                                <input type="text" class="form-control" v-model="form.quote_setting.lead_time" placeholder="Lead Time">
                            </div>
                        </div>
                    </div>

                    <div class="text-contbox mb-2">
                        <h4> Terms and conditions </h4>
                        <VueEditor v-model="form.quote_setting.terms" :config="editorConfig"></VueEditor>
                    </div>

                    <div class="row mb-1">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <label >Send Quote To Customer Mail Subject</label>
                                <input type="text" class="form-control" v-model="form.quote_setting.quote_send_to_customer_subject" placeholder="Send Quote To Customer Mail Subject">
                                <small id="quote_send_to_customer_subject_help" class="form-text text-muted">Supported template tags:- __CUSTOMER_NAME__ , __CUSTOMER_COMPANY_NAME__ , __QUOTE_NUMBER__</small>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <label >Send Quote To Customer Mail Body</label>
                                <VueEditor v-model="form.quote_setting.quote_send_to_customer_body" :config="editorConfig"></VueEditor>
                                <small id="quote_send_to_customer_body_help" class="form-text text-muted">Supported template tags:- __CUSTOMER_NAME__ , __CUSTOMER_COMPANY_NAME__ , __QUOTE_NUMBER__</small>
                            </div>
                        </div>

                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <label >Send Quote To Vendor Mail Subject</label>
                                <input type="text" class="form-control" v-model="form.quote_setting.quote_send_to_vendor_subject" placeholder="Send Quote To Vendor Mail Subject">
                                <small id="quote_send_to_vendor_subject_help" class="form-text text-muted">Supported template tags:- __VENDOR_NAME__ , __VENDOR_COMPANY_NAME__ , __QUOTE_NUMBER__</small>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <label >Send Quote To Vendor Mail Body</label>
                                <VueEditor v-model="form.quote_setting.quote_send_to_vendor_body" :editorToolbar="getXSmallQuillToolbar()"></VueEditor>
                                <small id="quote_send_to_vendor_body_help" class="form-text text-muted">Supported template tags:- __VENDOR_NAME__ , __VENDOR_COMPANY_NAME__ , __QUOTE_NUMBER__</small>

                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="d-flex align-items-center">
                        <h5 class="card-title flex-grow-1 mb-0">SO</h5>
                    </div>
                </div>
                <div class="card-body pb-0">
                    <div class="text-contbox">
                        <h4> Terms and conditions </h4>
                        <VueEditor v-model="form.so_setting.terms_so" :config="editorConfig"></VueEditor>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label >Send SO To Customer Mail Subject</label>
                        <input type="text" class="form-control" v-model="form.so_setting.so_send_to_customer_title" placeholder="Send SO To Customer Mail Subject">
                        <small id="so_send_to_customer_title_help" class="form-text text-muted">Supported template tags:- __CUSTOMER_NAME__ , __CUSTOMER_COMPANY_NAME__ , __ORDER_NUMBER__</small>
                    </div>
                    <div class="form-group">
                        <label >Send SO To Customer Mail Body</label>
                        <VueEditor v-model="form.so_setting.so_send_to_customer_body" :config="editorConfig"></VueEditor>
                        <small id="so_send_to_customer_body_help" class="form-text text-muted">Supported template tags:- __CUSTOMER_NAME__ , __CUSTOMER_COMPANY_NAME__ , __ORDER_NUMBER__</small>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label >Default SO Note</label>
                        <VueEditor v-model="form.so_setting.default_so_note" :config="editorConfig"></VueEditor>
                    </div>
                    <div class="custom-select-row">
                    <div class="form-group">
                        <label>Default Task Priority</label>
                        <select class="form-select" v-model="form.so_setting.so_task_priority_id">
                            <option :value="null">Select</option>
                            <option v-for="(item, index) in priorities" :value="item.id">
                                {{ item.priority_name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Red Task Priority</label>
                        <select class="form-select" v-model="form.so_setting.so_red_task_priority_id">
                            <option :value="null">Select</option>
                            <option v-for="(item, index) in priorities" :value="item.id">
                                {{ item.priority_name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Task Email/Notification Interval Days</label>
                        <select class="form-select" v-model="form.so_setting.so_task_notify_interval">
                            <option :value="null">Select</option>
                            <option v-for="(item, index) in days" :value="item">
                                {{ item }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Reminder Email/Notification Interval Days</label>
                        <select class="form-select" v-model="form.so_setting.so_reminder_notify_interval">
                            <option :value="null">Select</option>
                            <option v-for="(item, index) in days" :value="item">
                                {{ item }}
                            </option>
                        </select>
                    </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="d-flex align-items-center">
                        <h5 class="card-title flex-grow-1 mb-0">PO</h5>
                    </div>
                </div>
                <div class="card-body pb-0">
                    <h4> Terms and conditions </h4>
                    <div class="card p-2">
                        <VueEditor v-model="form.po_setting.terms_po" :config="editorConfig"></VueEditor>
                    </div>

                    <hr>
                    <div class="form-group">
                        <label >Send PO To Vendor Mail Subject</label>
                        <input type="text" class="form-control" v-model="form.po_setting.po_send_to_vendor_title" placeholder="Send PO To Vendor Mail Subject">
                        <small id="po_send_to_vendor_title_help" class="form-text text-muted">Supported template tags:- __VENDOR_NAME__ , __VENDOR_COMPANY_NAME__ , __PO_NUMBER__</small>
                    </div>
                    <div class="form-group">
                        <label >Send PO To Vendor Mail Body</label>
                        <VueEditor v-model="form.po_setting.po_send_to_vendor_body" :config="editorConfig"></VueEditor>
                        <small id="po_send_to_vendor_body_help" class="form-text text-muted">Supported template tags:- __VENDOR_NAME__ , __VENDOR_COMPANY_NAME__ , __PO_NUMBER__</small>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label >Default PO Note</label>
                        <VueEditor v-model="form.po_setting.default_po_note" :config="editorConfig"></VueEditor>
                    </div>

                    <div class="form-group">
                        <label >Default PO PDF Note</label>
                        <VueEditor v-model="form.po_setting.default_po_pdf_note" :config="editorConfig"></VueEditor>
                    </div>



                    <div class="custom-select-row">
                    <div class="form-group">
                        <label>Default Task Priority</label>
                        <select class="form-select" v-model="form.po_setting.po_task_priority_id">
                            <option :value="null">Select</option>
                            <option v-for="(item, index) in priorities" :value="item.id">
                                {{ item.priority_name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Red Task Priority</label>
                        <select class="form-select" v-model="form.po_setting.po_red_task_priority_id">
                            <option :value="null">Select</option>
                            <option v-for="(item, index) in priorities" :value="item.id">
                                {{ item.priority_name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Task Email/Notification Interval Days</label>
                        <select class="form-select" v-model="form.po_setting.po_task_notify_interval">
                            <option :value="null">Select</option>
                            <option v-for="(item, index) in days" :value="item">
                                {{ item }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Reminder Email/Notification Interval Days</label>
                        <select class="form-select" v-model="form.po_setting.po_reminder_notify_interval">
                            <option :value="null">Select</option>
                            <option v-for="(item, index) in days" :value="item">
                                {{ item }}
                            </option>
                        </select>
                    </div>
                    </div>
                </div>
            </div>

            <div class="btnrow text-right">
                <!-- <router-link :to="{name: 'viewCustomers'}" class="btn skip-btn">Discard</router-link> -->
                <button type="submit" class="btn btn-info w-md" id="save_customer_btn">Save</button>
                <!-- <a href="#" class="btn custom-btn ml-3">Save</a> -->
            </div>

        </div>
        </form>
        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import { VueEditor } from "vue2-editor";

export default {
    name: "GlobalSettings",
    components: {VueEditor},
    created() {
        this.getSettings();
        this.setSuccessMessage(null);

        this.days = [];
        for(let i = 1; i <= 30; i++) {
            this.days.push(i);
        }
    },
    data(){
        return {
             flatPickerConfig: {
                wrap: false, // set wrap to true only when using 'input-group'
                altFormat: 'Y-m-d',
                altInput: false,
                dateFormat: 'Y-m-d',
                //locale: Hindi, // locale for this instance only
            },
             editorConfig: [
                 [
                     {
                         'size': []
                     },
                     'bold',
                     {
                         'color': []
                     },
                     {
                         'background': []
                     },
                     {
                         'list': 'ordered'
                     },
                     {
                         'list': 'bullet'
                     }
                 ]
             ],
            editorConfigMin: {
                enterMode: 2,
                removePlugins: 'elementspath',
                resize_enabled: false,
                toolbar: [
                    [ 'Source', '-', 'Bold', 'Italic' ],
                    [ 'Styles', 'Format', 'Font', 'FontSize' ],
                ]
            },
            customerData: {
                customer: null,
                contacts: [],
                country_data: null,
                customer_contact: null,
                countries: [],
                can_add_customer: false,
                can_edit_customer: false,
                can_delete_customer: false,
                user_type: null,
                role: null
            },
            form: {
                smtp_server_name:1,
                smtp_host_name:null,
                smtp_port:null,
                smtp_encryption:null,
                smtp_user_name:null,
                smtp_password:null,
                imap_server_name:1,
                imap_host_name:null,
                imap_port:null,
                imap_encryption:null,
                imap_user_name:null,
                imap_password:null,
                quote_setting:{
                    max_products:null,
                    max_tiers:null,
                    address_1:null,
                    address_2:null,
                    phone:null,
                    fax:null,
                    terms:null,
                    lead_time:null,
                    quote_send_to_customer_subject:null,
                    quote_send_to_customer_body:null,
                    quote_send_to_vendor_subject:null,
                    quote_send_to_vendor_body:null,
                },
                so_setting:{
                    terms_so:null,
                    so_send_to_customer_title: null,
                    so_send_to_customer_body: null,
                    default_so_note: null,
                    so_task_priority_id: null,
                    so_red_task_priority_id: null,
                    so_task_notify_interval: null,
                    so_reminder_notify_interval: null,
                },
                po_setting:{
                    terms_po:null,
                    default_po_note:null,
                    po_task_priority_id: null,
                    po_red_task_priority_id: null,
                    po_task_notify_interval: null,
                    po_reminder_notify_interval: null,
                    po_send_to_vendor_title: null,
                    po_send_to_vendor_body: null,
                    default_po_pdf_note:null,
                }
            },
            priorities: [],
            days: [],
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        onEditorInput(event, type) {
            console.log(event)
        },
        getSettings() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            //this.setSuccessMessage(null);
            return axios.get(window.route('global-setting.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        let globalSetting =  data.data;
                        //console.log("globalSetting",globalSetting);
                        this.priorities = data.data.priorities;

                        this.form = {
                            smtp_server_name:globalSetting.smtp_data.smtp_server_name,
                            smtp_host_name:globalSetting.smtp_data.smtp_host_name,
                            smtp_port:globalSetting.smtp_data.smtp_port,
                            smtp_encryption:globalSetting.smtp_data.smtp_encryption,
                            smtp_user_name:globalSetting.smtp_data.smtp_user_name,
                            smtp_password:globalSetting.smtp_data.smtp_password,
                            imap_server_name:globalSetting.imap_data.imap_server_name,
                            imap_host_name:globalSetting.imap_data.imap_host_name,
                            imap_port:globalSetting.imap_data.imap_port,
                            imap_encryption:globalSetting.imap_data.imap_encryption,
                            imap_user_name:globalSetting.imap_data.imap_user_name,
                            imap_password:globalSetting.imap_data.imap_password,
                            quote_setting:{
                                max_products:globalSetting.quote_setting.max_products,
                                max_tiers:globalSetting.quote_setting.max_tiers,
                                address_1:globalSetting.quote_setting.address_1,
                                address_2:globalSetting.quote_setting.address_2,
                                phone:globalSetting.quote_setting.phone,
                                fax:globalSetting.quote_setting.fax,
                                terms:globalSetting.quote_setting.terms,
                                lead_time:globalSetting.quote_setting.lead_time,
                                quote_send_to_customer_subject:globalSetting.quote_setting.quote_send_to_customer_subject,
                                quote_send_to_customer_body:globalSetting.quote_setting.quote_send_to_customer_body,
                                quote_send_to_vendor_subject:globalSetting.quote_setting.quote_send_to_vendor_subject,
                                quote_send_to_vendor_body:globalSetting.quote_setting.quote_send_to_vendor_body,
                            },
                            so_setting:{
                                terms_so:globalSetting.so_setting.terms_so,
                                so_send_to_customer_title:globalSetting.so_setting.so_send_to_customer_title,
                                so_send_to_customer_body:globalSetting.so_setting.so_send_to_customer_body,
                                default_so_note:globalSetting.so_setting.default_so_note,
                                so_task_priority_id:globalSetting.so_setting.so_task_priority_id,
                                so_red_task_priority_id:globalSetting.so_setting.so_red_task_priority_id,
                                so_task_notify_interval:globalSetting.so_setting.so_task_notify_interval,
                                so_reminder_notify_interval:globalSetting.so_setting.so_reminder_notify_interval,
                            },
                            po_setting:{
                                terms_po:globalSetting.po_setting.terms_po,
                                default_po_note:globalSetting.po_setting.default_po_note,
                                po_task_priority_id:globalSetting.po_setting.po_task_priority_id,
                                po_red_task_priority_id:globalSetting.po_setting.po_red_task_priority_id,
                                po_task_notify_interval:globalSetting.po_setting.po_task_notify_interval,
                                po_reminder_notify_interval:globalSetting.po_setting.po_reminder_notify_interval,
                                po_send_to_vendor_title:globalSetting.po_setting.po_send_to_vendor_title,
                                po_send_to_vendor_body:globalSetting.po_setting.po_send_to_vendor_body,
                                default_po_pdf_note:globalSetting.po_setting.default_po_pdf_note,
                            }
                        }

                        //console.log("this.customerData",globalSetting.so_setting.terms_so );



                       /// this.form.id = data.data.customer.id;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        save() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            this.setSuccessMessage(null);
            return axios.post(window.route('global-setting.store'), this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSuccessMessage(data.data.message.message);
                        self.getSettings();
                        //self.$router.push({ name: 'viewCustomers' });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        onImapChange(newValue) {
            //console.log(newValue.target.value)
            if(newValue.target.value == 2) {
                this.form.imap_host_name = 'outlook.office365.com';
                this.form.imap_port = '993';
                this.form.imap_encryption = 'ssl';
                this.form.imap_user_name = '';
                this.form.imap_password = '';
            } else {
                this.form.imap_host_name = 'imap.gmail.com';
                this.form.imap_port = '993';
                this.form.imap_encryption = 'ssl';
                this.form.imap_user_name = '';
                this.form.imap_password = '';
            }
        },
        onSmtpChange(newValue) {
            if(newValue.target.value == 2) {
                this.form.smtp_host_name = 'smtp.office365.com';
                this.form.smtp_port = '587';
                this.form.smtp_encryption = 'tls';
                this.form.smtp_user_name = '';
                this.form.smtp_password = '';
            } else {
                this.form.smtp_host_name = 'smtp.gmail.com';
                this.form.smtp_port = '465';
                this.form.smtp_encryption = 'ssl';
                this.form.smtp_user_name = '';
                this.form.smtp_password = '';
            }
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    },
    watch: {
        /*'form.imap_server_name': {
            handler: function (newValue, oldValue) {
                if(newValue == 2) {
                    this.form.imap_host_name = 'outlook.office365.com';
                    this.form.imap_port = '993';
                    this.form.imap_encryption = 'ssl';
                    this.form.imap_user_name = '';
                    this.form.imap_password = '';
                } else {
                    this.form.imap_host_name = 'imap.gmail.com';
                    this.form.imap_port = '993';
                    this.form.imap_encryption = 'ssl';
                    this.form.imap_user_name = '';
                    this.form.imap_password = '';
                }
            }
        },
        'form.smtp_server_name': {
            handler: function (newValue, oldValue) {
                if(newValue == 2) {
                    this.form.smtp_host_name = 'smtp.office365.com';
                    this.form.smtp_port = '587';
                    this.form.smtp_encryption = 'tls';
                    this.form.smtp_user_name = '';
                    this.form.smtp_password = '';
                } else {
                    this.form.smtp_host_name = 'smtp.gmail.com';
                    this.form.smtp_port = '465';
                    this.form.smtp_encryption = 'ssl';
                    this.form.smtp_user_name = '';
                    this.form.smtp_password = '';
                }
            }
        },*/
    }
}
</script>

<style scoped>

</style>
